export const ACTIVE_BRANCH_ELEMENT_KEY = 'activeBranchElement'
